export type TurnPhase = 'idle' | 'capturing' | 'flushing' | 'awaiting_model' | 'playing' | 'finalizing';

export type VoiceStateDisplay = {
  label: string;
  dotClass: string;
  textClass: string;
  panelClass: string;
};

const IDLE_HANDS_FREE_STATE: VoiceStateDisplay = {
  label: 'Listening',
  dotClass: 'bg-sky-400',
  textClass: 'text-sky-400',
  panelClass: 'bg-sky-500/10 border-sky-500/30',
};

const IDLE_PTT_STATE: VoiceStateDisplay = {
  label: 'Idle',
  dotClass: 'bg-sky-400',
  textClass: 'text-sky-400',
  panelClass: 'bg-sky-500/10 border-sky-500/30',
};

const WAITING_STATE: VoiceStateDisplay = {
  label: 'Waiting',
  dotClass: 'bg-indigo-400 animate-pulse',
  textClass: 'text-indigo-400',
  panelClass: 'bg-indigo-500/10 border-indigo-500/30',
};

const THINKING_STATE: VoiceStateDisplay = {
  label: 'Thinking',
  dotClass: 'bg-violet-400 animate-pulse',
  textClass: 'text-violet-400',
  panelClass: 'bg-violet-500/10 border-violet-500/30',
};

const SPEAKING_STATE: VoiceStateDisplay = {
  label: 'Speaking',
  dotClass: 'bg-green-400 animate-pulse',
  textClass: 'text-green-400',
  panelClass: 'bg-green-500/10 border-green-500/30',
};

const WRAPPING_UP_STATE: VoiceStateDisplay = {
  label: 'Wrapping Up',
  dotClass: 'bg-yellow-400 animate-pulse',
  textClass: 'text-yellow-400',
  panelClass: 'bg-yellow-500/10 border-yellow-500/30',
};

const FINISHING_STATE: VoiceStateDisplay = {
  label: 'Finishing',
  dotClass: 'bg-yellow-400 animate-pulse',
  textClass: 'text-yellow-400',
  panelClass: 'bg-yellow-500/10 border-yellow-500/30',
};

export function deriveHandsFreeState(
  turnPhase: TurnPhase,
  isAiThinking: boolean,
  isAiSpeaking: boolean,
): VoiceStateDisplay {
  if (turnPhase === 'playing' || isAiSpeaking) {
    return SPEAKING_STATE;
  }

  if (turnPhase === 'capturing') {
    return {
      label: 'Capturing',
      dotClass: 'bg-amber-400 animate-pulse',
      textClass: 'text-amber-400',
      panelClass: 'bg-amber-500/10 border-amber-500/30',
    };
  }

  if (turnPhase === 'flushing') {
    return WRAPPING_UP_STATE;
  }

  if (isAiThinking) {
    return THINKING_STATE;
  }

  if (turnPhase === 'awaiting_model') {
    return WAITING_STATE;
  }

  if (turnPhase === 'finalizing') {
    return FINISHING_STATE;
  }

  return IDLE_HANDS_FREE_STATE;
}

export function derivePttState(turnPhase: TurnPhase, isAiThinking: boolean, isAiSpeaking: boolean, isPttActive: boolean): VoiceStateDisplay {
  if (turnPhase === 'playing' || isAiSpeaking) {
    return SPEAKING_STATE;
  }

  if (isPttActive || turnPhase === 'capturing') {
    return {
      label: 'Listening',
      dotClass: 'bg-amber-400 animate-pulse',
      textClass: 'text-amber-400',
      panelClass: 'bg-amber-500/10 border-amber-500/30',
    };
  }

  if (turnPhase === 'flushing') {
    return WRAPPING_UP_STATE;
  }

  if (isAiThinking) {
    return THINKING_STATE;
  }

  if (turnPhase === 'awaiting_model') {
    return WAITING_STATE;
  }

  if (turnPhase === 'finalizing') {
    return FINISHING_STATE;
  }

  return IDLE_PTT_STATE;
}
